import React from 'react';
import Image from 'next/image';

export type BrandWordmarkProps = {
	className?: string;
};

export const BrandWordmark: React.FC<BrandWordmarkProps> = ( { className } ) => (
	<Image
		src='/Logo.svg'
		alt='Rock Paper Coin'
		width={ 377 }
		height={ 119 }
		className={ className }
	/>
);
